import type { ExternalTableSchema } from '@packages/table-builder';

export const PPT_ACCESS_LIST_STATUS = {
  Eligible: 1,
  Enrolled: 2,
  Revoked: 3,
} as const;

const STATUS_OPTIONS = [
  { label: 'Eligible', value: PPT_ACCESS_LIST_STATUS.Eligible },
  { label: 'Enrolled', value: PPT_ACCESS_LIST_STATUS.Enrolled },
  { label: 'Revoked', value: PPT_ACCESS_LIST_STATUS.Revoked },
];

export const pptAccessListTableSchema: ExternalTableSchema = {
  metadata: {
    title: 'Advisor PPT Access',
    entity: 'PPT Access Record',
  },

  dataSource: {
    endpoint: '/api/customer/api/app/ppt-access-list-issuer',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'advisorCompanyIds',
        placeholder: 'Advisor Company',
        type: 'asyncSelect',
        multiple: true,
        dataSource: {
          url: '/api/customer/api/app/ppt-access-list-issuer/service-companies',
          labelField: 'name',
          valueField: 'companyId',
        },
      },
      {
        name: 'status',
        placeholder: 'Status',
        type: 'select',
        options: STATUS_OPTIONS,
      },
      {
        name: 'participantName',
        placeholder: 'Participant Name',
        type: 'text',
      },
      {
        name: 'employeeId',
        placeholder: 'Employee ID',
        type: 'text',
      },
    ],
  },

  columns: [
    {
      field: 'pptEmpId',
      header: 'Employee ID',
      sortable: false,
      width: 140,
      visibility: 'locked',
    },
    {
      field: 'pptFname',
      header: 'Participant',
      type: 'couple',
      sortable: false,
      width: 200,
      couple: {
        titleField: 'pptFname',
        subtitleField: 'pptLName',
      },
    },
    {
      field: 'advisorCompanyName',
      header: 'Advisor Company',
      sortable: false,
      width: 200,
    },
    {
      field: 'status',
      header: 'Status',
      type: 'badge',
      sortable: false,
      width: 120,
      align: 'center',
      badge: {
        statusMap: {
          Eligible: 'info',
          Enrolled: 'success',
          Revoked: 'error',
        },
      },
    },
    {
      field: 'originType',
      header: 'Origin',
      sortable: false,
      width: 140,
    },
    {
      field: 'creationTime',
      header: 'Created',
      type: 'date',
      sortable: false,
      width: 140,
    },
    {
      field: 'lastModificationTime',
      header: 'Last Updated',
      type: 'date',
      sortable: false,
      width: 140,
    },
  ],

  actions: {
    toolbar: {
      secondary: [
        { id: 'IMPORT_PPT_ACCESS_LIST', label: 'Import', icon: 'upload' },
        {
          label: 'Downloads',
          icon: 'download',
          type: 'download',
          children: [
            { id: 'EXPORT_PPT_ACCESS_LIST', label: 'Export List' },
            { id: 'DOWNLOAD_PPT_ACCESS_TEMPLATE', label: 'Download Template' },
          ],
        },
      ],
    },
  },

  features: {
    pagination: { defaultSize: 25, mode: 'pagination' },
    selection: { keyField: 'id', selectAllPages: true },
    columnPreferences: {
      persistenceKey: 'PptAccessList',
      resizable: true,
      reorderable: true,
    },
  },
};
